import React from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { CartProvider } from './context/CartContext';
import Navigation from './components/Navigation';
import B2BNotice from './components/B2BNotice';
import CookieConsent from './components/CookieConsent';
import LandingPage from './pages/LandingPage';
import ProductPage from './pages/ProductPage';
import ConfiguratorPage from './pages/ConfiguratorPage';
import CartPage from './pages/CartPage';
import LegalPage from './pages/LegalPage';
import GalleryPage from './pages/GalleryPage';

function App() {
  return (
    <CartProvider>
      <div className="App min-h-screen bg-[#09090b]">
        <BrowserRouter>
          <Navigation />
          <div className="pt-16 md:pt-20">
            <B2BNotice />
          </div>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/produkt" element={<ProductPage />} />
            <Route path="/configurator" element={<ConfiguratorPage />} />
            <Route path="/cart" element={<CartPage />} />
            <Route path="/galerie" element={<GalleryPage />} />
            <Route path="/legal" element={<LegalPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster 
          position="bottom-right" 
          theme="dark"
          toastOptions={{
            style: {
              background: '#18181b',
              border: '1px solid #27272a',
              color: '#fafafa',
            },
          }}
        />
        <CookieConsent />
        {/* Noise overlay for texture */}
        <div className="noise-overlay" />
      </div>
    </CartProvider>
  );
}

export default App;
